import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// recoil
import { RecoilRoot } from 'recoil'

// BrowserRouter
import { BrowserRouter } from 'react-router-dom';

// Chakra
import { CustomTheme } from './helpers/theme';
import { ChakraProvider, CSSReset } from '@chakra-ui/core';


// Sentry
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";


Sentry.init({
  dsn: process.env.REACT_APP_DSN,
  integrations: [
    new Integrations.BrowserTracing(),
  ],
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <ChakraProvider theme={CustomTheme}>
    <CSSReset />
    <BrowserRouter>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </BrowserRouter>
  </ChakraProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

